/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentTableData {
    getFixupPrototypeFunction() { return AgentTableData.fixupPrototype; }

    static newInstance(model: Partial<AgentTableData>): AgentTableData {
        let obj = Object.assign(new AgentTableData(), model);
        AgentTableData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentTableData>): AgentTableData {
        if (!model) return null;
        return AgentTableData.newInstance(<AgentTableData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentTableData) {
        if (!obj) return;

        models.AgentTableData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentTableData): boolean {
        Object.setPrototypeOf(obj, AgentTableData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Headers of the table.
     */
    headers: Array<string>;

    /**
     * Rows of the table.
     */
    rows: any;

}
